import React from "react";
import SideMenuBar from "../../components/account/SideMenuBar";
import RightBar from "../../components/account/RightBar";
import HistoriesContent from "../../components/account/HistoriesContent";
import { isMobilePage } from "../../common/cores";
import { isMobile } from "../../utils/utils";
import { MobileFootbar } from "../../components/Layout/Footbar";

const Histories = () => {
  return (
    <div
      data-v-623d66c4=""
      className="contents row"
      style={{ flexDirection: "row" }}
    >
      <div data-v-623d66c4="" className="content column right-content">
        <div data-v-623d66c4="" className="column">
          <div
            data-v-394b74b4=""
            data-v-623d66c4=""
            className="account row"
            style={{ flexDirection: "row" }}
          >
            {!isMobilePage() && <SideMenuBar />}
            <HistoriesContent />
          </div>
        </div>
      </div>
      {!isMobilePage() && <RightBar />}
    </div>
  );
};

export default Histories;



// WEBPACK FOOTER //
// ./src/containers/Account/Histories.js